import { createSelector } from "@ngrx/store";
import { AppState } from "../app.state";

export const ETARequired = (state : AppState) => state.etaRequired

export const getETARequired = createSelector(
    ETARequired,
    (etaRequired) => etaRequired
)